"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cutAccordion = exports.copyAccordion = exports.decodeTransferValue = exports.cutFromNestedStructure = exports.copyCurrentSelectionToClipboardAsPlainText = exports.copyFromNestedStructure = exports.extractSelectedCells = exports.cutWidget = exports.copyWidget = exports.cutSideBySide = exports.copySideBySide = exports.cutTable = exports.copyTable = void 0;
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var EditorTypes_1 = require("./../EditorTypes");
var Deserialise_1 = require("./../Tokenization/Deserialise");
var Serialise_1 = require("./../Tokenization/Serialise");
var EventTransfer_1 = require("../EventTransfer");
var TokenRenderer_1 = __importDefault(require("ContentTokens/TokenRenderer"));
var Utils_1 = require("../Utils");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var TableActions = __importStar(require("./TableActions"));
var AccordionActions_1 = require("./Accordion/AccordionActions");
var isHandledCopy = function (result) { return result.handled; };
var copyTable = function (event, editor) {
    if (!editor.selection) {
        return { handled: undefined };
    }
    var selection = editor.selection;
    var tableEntry = (0, Utils_1.checkAncestors)(editor, slate_1.Range.start(selection).path, function (node) {
        return node.type === EditorTypes_1.BlockType.Table;
    });
    if (!tableEntry) {
        return { handled: undefined };
    }
    var tableToken = (0, Serialise_1.serialiseBlock)(tableEntry[0], editor);
    var subTableToken = (0, exports.extractSelectedCells)(tableToken[0]);
    if (!subTableToken) {
        return { handled: undefined };
    }
    var fragment = (0, Deserialise_1.deserialise)([subTableToken]).children;
    var fragmentTransfer = createTransferValue(fragment);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", (0, TokenRenderer_1.default)([subTableToken]));
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", fragmentTransfer);
    return { handled: true, nodeEntry: tableEntry };
};
exports.copyTable = copyTable;
var cutTable = function (event, editor) {
    var copyResult = (0, exports.copyTable)(event, editor);
    if (isHandledCopy(copyResult)) {
        var selectedCells = copyResult.nodeEntry[0].data.selection.selectedCells;
        var isEntireTableSelected = selectedCells.length === selectedCells.filter(function (c) { return c; }).length;
        if (isEntireTableSelected) {
            slate_1.Transforms.removeNodes(editor, { at: copyResult.nodeEntry[1] });
        }
        else {
            TableActions.clearSelectedCells(editor);
        }
    }
    return copyResult;
};
exports.cutTable = cutTable;
var copySideBySide = function (event, editor) {
    if (!editor.selection) {
        return { handled: undefined };
    }
    var selection = editor.selection;
    var sideBySideEntry = (0, Utils_1.checkAncestors)(editor, slate_1.Range.start(selection).path, function (node) {
        return node.type === EditorTypes_1.BlockType.SideBySide;
    });
    if (!sideBySideEntry) {
        return { handled: undefined };
    }
    var sideBySideToken = (0, Serialise_1.serialiseBlock)(sideBySideEntry[0], editor);
    var fragment = (0, Deserialise_1.deserialise)(sideBySideToken).children;
    var fragmentToTransfer = createTransferValue(fragment);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", (0, TokenRenderer_1.default)(sideBySideToken));
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", fragmentToTransfer);
    return { handled: true, nodeEntry: sideBySideEntry };
};
exports.copySideBySide = copySideBySide;
var cutSideBySide = function (event, editor) {
    var copyResult = (0, exports.copySideBySide)(event, editor);
    if (isHandledCopy(copyResult)) {
        slate_1.Transforms.removeNodes(editor, { at: copyResult.nodeEntry[1] });
    }
    return copyResult.handled;
};
exports.cutSideBySide = cutSideBySide;
var copyWidget = function (event, editor) {
    var node = slate_react_1.ReactEditor.toSlateNode(editor, event.target);
    var path = slate_react_1.ReactEditor.findPath(editor, node);
    var voidEntry = slate_1.Editor.void(editor, { at: path });
    var _a = __read(voidEntry, 1), voidNode = _a[0];
    var cutTokens = (0, Serialise_1.serialise)([voidNode]);
    var transferHtml = (0, TokenRenderer_1.default)(cutTokens);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", transferHtml);
    var transferFragment = createTransferValue([voidNode]);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", transferFragment);
    return { handled: true, nodeEntry: voidEntry };
};
exports.copyWidget = copyWidget;
var cutWidget = function (event, editor) {
    var copyResult = (0, exports.copyWidget)(event, editor);
    slate_1.Transforms.removeNodes(editor, { at: copyResult.nodeEntry[1] });
};
exports.cutWidget = cutWidget;
var extractSelectedCells = function (tableToken) {
    var e_1, _a;
    var selectedCells = tableToken.selection.selectedCells;
    var newCells = [];
    var newRepeatingRows = [];
    var cellCount = 0;
    for (var i = 0; i < tableToken.cells.length; i++) {
        var newRow = [];
        var row = tableToken.cells[i];
        try {
            for (var row_1 = (e_1 = void 0, __values(row)), row_1_1 = row_1.next(); !row_1_1.done; row_1_1 = row_1.next()) {
                var cell = row_1_1.value;
                if (selectedCells[cellCount]) {
                    newRow.push(cell);
                }
                cellCount++;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (row_1_1 && !row_1_1.done && (_a = row_1.return)) _a.call(row_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (newRow.length) {
            newCells.push(newRow);
            var newRepeatingRow = calculateNewRepeatingRow(tableToken.repeatingRows, i, newCells.length - 1);
            if (newRepeatingRow) {
                newRepeatingRows.push(newRepeatingRow);
            }
        }
    }
    if (newCells.length) {
        return TokenModels_1.default.table.createToken(newCells.length, newCells[0].length, newCells, undefined, newRepeatingRows);
    }
    return;
};
exports.extractSelectedCells = extractSelectedCells;
var calculateNewRepeatingRow = function (currentRepeatingRows, currentRowIndex, newRowIndex) {
    if (currentRepeatingRows) {
        var currentRepeatingRow = currentRepeatingRows.find(function (r) { return r.rowIndex === currentRowIndex; });
        if (currentRepeatingRow) {
            return { rowIndex: newRowIndex, repeatingToken: currentRepeatingRow.repeatingToken };
        }
    }
};
var copyFromNestedStructure = function (event, editor) {
    if (!editor.selection || slate_1.Range.isCollapsed(editor.selection)) {
        return;
    }
    var selection = editor.selection;
    var closestBlockEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(selection).path);
    if (!closestBlockEntry) {
        return;
    }
    var depth = closestBlockEntry[1].length;
    var fragment = slate_1.Editor.fragment(editor, editor.selection);
    var filtered = Array.from(slate_1.Node.nodes({ children: fragment }))
        .filter(function (curr) {
        return curr[1].length === depth;
    })
        .map(function (entry) {
        return entry[0];
    });
    (0, exports.copyCurrentSelectionToClipboardAsPlainText)(event, editor);
    var copyTokens = (0, Serialise_1.serialise)(filtered);
    var transferHtml = (0, TokenRenderer_1.default)(copyTokens);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", transferHtml);
    var transferFragment = createTransferValue(filtered);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", transferFragment);
    return true;
};
exports.copyFromNestedStructure = copyFromNestedStructure;
var copyCurrentSelectionToClipboardAsPlainText = function (event, editor) {
    var selection = editor.selection;
    if (!selection || slate_1.Range.isCollapsed(selection)) {
        return;
    }
    var selectedText = slate_1.Editor.string(editor, selection);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "text", selectedText);
};
exports.copyCurrentSelectionToClipboardAsPlainText = copyCurrentSelectionToClipboardAsPlainText;
var cutFromNestedStructure = function (event, editor) {
    var handled = (0, exports.copyFromNestedStructure)(event, editor);
    if (handled) {
        slate_1.Transforms.delete(editor);
    }
    return handled;
};
exports.cutFromNestedStructure = cutFromNestedStructure;
var createTransferValue = function (fragment) {
    return window.btoa(encodeURIComponent(JSON.stringify(fragment)));
};
var decodeTransferValue = function (encodedFragment) {
    return JSON.parse(decodeURIComponent(window.atob(encodedFragment)));
};
exports.decodeTransferValue = decodeTransferValue;
var copyAccordion = function (event, editor) {
    if (!editor.selection) {
        return { handled: undefined };
    }
    var selection = editor.selection;
    var accordionEntry = (0, Utils_1.checkAncestors)(editor, slate_1.Range.start(selection).path, AccordionActions_1.accordionMatcher);
    if (!accordionEntry) {
        return { handled: undefined };
    }
    var accordionToken = (0, Serialise_1.serialiseBlock)(accordionEntry[0], editor);
    var fragment = (0, Deserialise_1.deserialise)(accordionToken).children;
    var fragmentToTransfer = createTransferValue(fragment);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", (0, TokenRenderer_1.default)(accordionToken));
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", fragmentToTransfer);
    return { handled: true, nodeEntry: accordionEntry };
};
exports.copyAccordion = copyAccordion;
var cutAccordion = function (event, editor) {
    var copyResult = (0, exports.copyAccordion)(event, editor);
    if (isHandledCopy(copyResult)) {
        slate_1.Transforms.removeNodes(editor, { at: copyResult.nodeEntry[1] });
    }
    return copyResult.handled;
};
exports.cutAccordion = cutAccordion;
